import React from 'react';
import { CheckIcon } from './icons';
import { Field } from './FormPage';

export interface ChipOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

interface ChipGroupProps {
  label: string;
  /** radio — один вариант (пол), checkbox — несколько (роли) */
  type: 'radio' | 'checkbox';
  name: string;
  options: ChipOption[];
  selected: Array<string | number>;
  onToggle: (value: string | number, checked: boolean) => void;
  /** Узкие карточки (не растягиваются на всю строку) */
  compact?: boolean;
  loading?: boolean;
  emptyText?: string;
  hint?: React.ReactNode;
  error?: React.ReactNode;
}

/** Выбор из нескольких вариантов карточками-переключателями (пол, роли). */
export const ChipGroup: React.FC<ChipGroupProps> = ({
  label, type, name, options, selected, onToggle, compact, loading, emptyText = 'Нет доступных вариантов', hint, error,
}) => {
  const labelId = `chips-${name}`;
  return (
    <div className="form-page__row form-page__row--single">
      <Field label={label} hint={hint} error={error}>
        <div
          className={`form-page__roles${compact ? ' form-page__roles--compact' : ''}`}
          role={type === 'radio' ? 'radiogroup' : 'group'}
          aria-labelledby={labelId}
        >
          <span id={labelId} hidden>{label}</span>
          {loading && (
            <>
              <span className="form-page__role form-page__role--skeleton" />
              <span className="form-page__role form-page__role--skeleton" />
            </>
          )}
          {!loading && options.length === 0 && <span className="form-page__hint">{emptyText}</span>}
          {options.map((option) => {
            const checked = selected.includes(option.value);
            return (
              <label
                key={option.value}
                className={`form-page__role${checked ? ' form-page__role--active' : ''}`}
              >
                <input
                  className="form-page__role-input"
                  type={type}
                  name={name}
                  value={option.value}
                  checked={checked}
                  disabled={option.disabled}
                  onChange={(e) => onToggle(option.value, e.target.checked)}
                />
                <span className="form-page__role-mark"><CheckIcon /></span>
                <span className="form-page__role-name">{option.label}</span>
              </label>
            );
          })}
        </div>
      </Field>
    </div>
  );
};
